import axios from "axios";
import { API_BASE_URL } from "../../../constants";

// Rep Mode V2 API client (same conventions as the coach client).

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const unwrapError = (error) => {
  if (error.response) {
    const detail = error.response.data
      ? error.response.data.error || error.response.data.detail || JSON.stringify(error.response.data)
      : error.response.statusText;
    throw new Error(`HTTP ${error.response.status}: ${detail}`);
  }
  throw error;
};

const get = async (path, params) => {
  try {
    const response = await axios.get(`${API_BASE_URL}${path}`, { headers: authHeaders(), params });
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
};

const send = async (method, path, body) => {
  try {
    const response = await axios({ method, url: `${API_BASE_URL}${path}`, data: body, headers: authHeaders() });
    return response.data;
  } catch (error) {
    return unwrapError(error);
  }
};

const staff = (repEmail) => (repEmail ? { repEmail } : undefined);

export const fetchRepHome = (repEmail) => get("/rep/home/", staff(repEmail));
export const fetchRepAthletes = (repEmail) => get("/rep/athletes/", staff(repEmail));
export const fetchRepCircle = (repEmail) => get("/rep/circle/", staff(repEmail));
export const fetchRepBadges = () => get("/rep/badges/");
export const fetchRepMe = () => get("/rep/me/");
// kind: message | notify | request_link
export const logRepContact = (payload) => send("post", "/rep/contact/", payload);
